import { Icon, IconButton, Tooltip } from "@mui/material";
import React from "react";

type ToolTipProps = Parameters<typeof Tooltip>[0];

type Props = Parameters<typeof IconButton>[0] & {
  icon?: string;
  tooltip?: string | ({ title: string } & Partial<ToolTipProps>); // partial because I won't be passing in the children
};

const MyconBtn: React.FunctionComponent<Props> = (props) => {
  const borderOverride = props.className?.split(" ")?.includes("border"); // was having a hard time setting the border with tailwind, even with !tags, so I'm creating this backdoor into styling, because I really like a bordered button
  const { tooltip, icon, children } = props;
  const ret = (
    <IconButton
      size="small" // default to small, becuase meidum is kinda huge, can be overwritten with props
      style={borderOverride ? { border: "1px solid #0000" } : {}}
      {...props}>
      <Icon>{children || icon}</Icon>
      {/* I obviously want an icon in my icon button... so this automatically passes the children (an icon selector) to the icon renderer */}
    </IconButton>
  );
  return !tooltip ? (
    ret
  ) : typeof tooltip === "string" ? (
    <Tooltip title={tooltip}>{ret}</Tooltip>
  ) : (
    <Tooltip {...{ ...tooltip, children: ret }} />
  );
};

export default MyconBtn;
